import type { z } from "zod";

import { captureNonBlockingError } from "@/lib/observability.ts";

export function createBestEffortValidate(errorMessage: string) {
  return <T>(validator: z.ZodType<T>) =>
    (response: { data: T }): T => {
      const { data } = response;
      const result = validator.safeParse(data);
      if (result.success) {
        return result.data;
      }
      // In case of validation failure, we fall back to the original data.
      // It will probably ripple down as runtime errors but we hope those errors will be very local / most of the application will still work.
      captureNonBlockingError(new Error(errorMessage), {
        validationError: result.error.format(),
      });

      return data;
    };
}

/**
 * Create a single-error logger that only logs the first error to Sentry.
 */
export function createSingleErrorLogger() {
  let hasLogged = false;
  return (error: Error, context?: object) => {
    if (hasLogged) {
      return;
    }
    hasLogged = true;
    captureNonBlockingError(error, context);
  };
}
